import { useAuth } from '@/contexts/AuthContext';
import { useFilters } from '@/contexts/FilterContext';

const ROLE_PERMISSIONS: Record<string, string[] | ['*']> = {
  super_admin: ['*'],
  admin: [
    'tenants:read',
    'tenants:write',
    'billing:read',
    'billing:write',
    'billing:nfse_issue',
    'audit:read'
  ],
  operator: ['tenants:read', 'tenants:write', 'billing:read', 'audit:read'],
  auditor: ['tenants:read', 'billing:read', 'audit:read']
};

export function useAdminPermissions() {
  const { admin } = useAuth();
  const { productId } = useFilters();

  const permissions = admin ? ROLE_PERMISSIONS[admin.role] || [] : [];
  const productScopes = admin?.productScopes?.length
    ? admin.productScopes
    : admin?.role === 'super_admin'
      ? ['*']
      : ['vover-app'];

  const can = (permission: string): boolean => {
    if (!admin) return false;
    if (permissions.includes('*')) return true;
    return permissions.includes(permission);
  };

  const canAccessProduct = (appId: string): boolean => {
    if (productScopes.includes('*')) return true;
    return productScopes.includes(appId);
  };

  const isVoverApp = productId === 'vover-app';

  return {
    admin,
    productId,
    productScopes,
    can,
    canAccessProduct,
    isVoverApp,
    isSuperAdmin: admin?.role === 'super_admin'
  };
}
